module.exports = __webpack_public_path__ + "img/41_31.7d5b2fb4.png";